import cookie from './cookie'

// 错误码
const errorCodes = {
    /** 默认 */
    default: -999,
    /** 返回为空 */
    empty: 'empty',
}

// 成功返回码
const successReturnCode = 200

// TODO: 从兼容性考虑，暂时先用 window
export const monitor = window.YYBMonitorWebSDK
    ? window.YYBMonitorWebSDK.Monitor.init({
          appName: 'channel_system',
          aegisId: 'vSofPiubKkUQKMHwYu',
          aegisConfig: {
              spa: true,
              reportApiSpeed: true,
              reportAssetSpeed: true,
              uin: cookie.get('channel_ovb_open_openid') || '',
              ext1: cookie.get('ptui_loginuin') || '',
              api: {
                  // 接口返回码处理
                  retCodeHandler(data) {
                      try {
                          const resp = JSON.parse(data)

                          if (!resp) {
                              return {
                                  isErr: true,
                                  code: errorCodes.empty,
                              }
                          }

                          return {
                              isErr: resp.c !== successReturnCode,
                              code: resp.c,
                          }
                      } catch {
                          return {
                              isErr: true,
                              code: errorCodes.default,
                          }
                      }
                  },
              },
          },
      })
    : undefined
